/**
 * Hands a code from the notice pop-up (Generate Code) to the entry form's Under-The-Crown
 * Code field. The code is parked in sessionStorage so it survives the form mounting later
 * (another page, or the Magic template's code step), and an event fills a form that's
 * already on screen.
 */
const PENDING_KEY = 'pending_entry_code';
export const PREFILL_EVENT = 'bloom:prefill-code';

export function prefillEntryCode(code) {
  try {
    sessionStorage.setItem(PENDING_KEY, code);
  } catch {
    /* storage unavailable — the event below still fills a form that's on screen */
  }
  window.dispatchEvent(new CustomEvent(PREFILL_EVENT, { detail: code }));
}

/** Returns the parked code (if any) and clears it, so it's only filled in once. */
export function takePendingEntryCode() {
  try {
    const code = sessionStorage.getItem(PENDING_KEY) || '';
    sessionStorage.removeItem(PENDING_KEY);
    return code;
  } catch {
    return '';
  }
}

/** Clears the parked code once a form on screen has used it from the event. */
export function clearPendingEntryCode() {
  try {
    sessionStorage.removeItem(PENDING_KEY);
  } catch {
    /* nothing to clear */
  }
}
